var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { attrs: { id: "document-automations-container" } },
    [
      _vm.loading
        ? _c("document-level-automations-loader")
        : _vm.noAutomations
        ? _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "no-results",
                    {
                      attrs: {
                        "img-src": require("@Shared/@Assets/img/application-missing.png"),
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("automations.noAutomationsToShow")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _vm._l(
                        _vm.documentRequestAutomationsByGroup,
                        function (automations, group) {
                          return [
                            _c(
                              "div",
                              { key: _vm.getGroupName(group) },
                              [
                                _c("document-automation-request-card-header", {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle",
                                      value:
                                        "collapse-" + _vm.getGroupName(group),
                                      expression:
                                        "`collapse-${getGroupName(group)}`",
                                    },
                                  ],
                                  staticClass: "mb-3",
                                  attrs: {
                                    group: group,
                                    "group-key": _vm.getGroupKey(group),
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-collapse",
                                  {
                                    attrs: {
                                      id: "collapse-" + _vm.getGroupName(group),
                                      visible: "",
                                    },
                                  },
                                  _vm._l(automations, function (automation) {
                                    return _c(
                                      "document-automation-request-card",
                                      {
                                        key: automation.id,
                                        attrs: { automation: automation },
                                      }
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _vm._v(" "),
      _c("manage-document-type-modal", {
        ref: "manageDocumentTypes",
        attrs: { "document-types-data": _vm.DOCUMENT_TYPES_DATA },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }